import React from 'react'
import classnames from 'classnames'

export const TH: React.FC<{ children: React.ReactNode, align?: 'left' | 'right' }> = ({
  children,
  align = 'left',
}) => (
  <th
    className={classnames(
      'px-3 py-2 text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400',
      align === 'right' ? 'text-right' : 'text-left'
    )}
  >
    {children}
  </th>
)

export const TD: React.FC<{
  children: React.ReactNode
  align?: 'left' | 'right'
  className?: string
  alert?: boolean
}> = ({ children, align = 'left', className, alert }) => (
  <td
    className={classnames(
      'px-3 py-2 text-sm',
      align === 'right' ? 'text-right' : 'text-left',
      alert === true
        ? 'font-semibold text-red-600 dark:text-red-400'
        : 'text-slate-700 dark:text-slate-200',
      className
    )}
  >
    {children}
  </td>
)
